import { isEmpty } from "lodash";
import moment from "moment";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import ThemeContext from "../../context/ThemeContext";

const Leagues = ({ data }) => {
  const [active, setActive] = useState({});
  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });
  const navigate = useNavigate();
  return (
    <div className="s-relative s-min-h-full-with-header s-pb-20px">
      {!isEmpty(active) ? (
        <div className>
          <section>
            <div className="s-py-15px s-px-4 s-flex s-items-center s-justify-center s-text-14px s-shadow-sm s-bg-white dark:s-bg-main-block-dark s-text-global-font-default-light dark:s-text-global-font-default-dark">
              <div
                onClick={() => setActive({})}
                className="s-icon-arrow-left s-mr-4"
              />
              <div className="s-flex-1 s-leading-20px">
                {active?.seriesName}
              </div>
            </div>
          </section>
          <section className="s-px-4 s-my-14px s-text-global-font-default-light dark:s-text-global-font-default-dark">
            <div>
              <div className="s-rounded-5px s-text-15px s-shadow-sm s-bg-white dark:s-bg-main-block-dark s-divide-y s-divide-black-300 dark:s-divide-black-900">
                {active?.matchList?.map((res) => {
                  return (
                    <div
                      onClick={() =>
                        navigate(
                          `/match-detail/${res?.eventId}/${res?.marketId}`,
                        )
                      }
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                      data-v-753c62c9
                      className="s-event-row s-grid s-gap-14px s-py-7px s-px-14px s-justify-between s-items-center"
                      data-should-render-scores-column="false"
                    >
                      <div data-v-753c62c9 className="s-flex s-flex-col">
                        <div
                          data-v-753c62c9
                          className="s-flex s-justify-between s-items-center s-gap-10px"
                        >
                          <div
                            data-v-753c62c9
                            className="s-text-17px s-font-bold s-leading-120 s-break-words s-text-global-font-default-light dark:s-text-global-font-default-dark"
                          >
                            <span data-v-753c62c9>{res?.eventName}</span>
                          </div>
                        </div>
                        <div
                          data-v-753c62c9
                          className="s-flex s-py-2px s-gap-3px s-leading-14px"
                        >
                          <div data-v-753c62c9>
                            <div
                              data-v-753c62c9
                              className="s-overflow-hidden s-flex s-flex-col s-rounded-3px"
                            >
                              <div className="s-time-block s-flex s-items-center s-justify-center s-flex-1 s-bg-tomorrow-light dark:s-bg-tomorrow-dark">
                                <span className="s-text-12px s-leading-120 s-text-black s-text-center s-whitespace-nowrap s-px-3px s-py-0">
                                  {moment(res?.eventDateTime).format("DD/MM")}
                                </span>
                                <span className="s-text-12px s-leading-120 s-text-black s-text-center s-pr-3px">
                                  {moment(res?.eventDateTime).format("hh:mm")}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div
                            data-v-753c62c9
                            className="s-text-12px s-font-normal s-leading-120 s-text-black-600"
                          >
                            <span data-v-753c62c9 className="s-pr-1">
                              Matched
                            </span>
                            <span data-v-753c62c9>
                              {res?.totalMatched || 0}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        data-v-753c62c9
                        className="s-flex s-gap-10px s-justify-end s-items-center"
                      >
                        {/**/}
                        <span
                          data-v-753c62c9
                          className="s-block s-icon-arrow-left s-transform s-rotate-180 s-text-12px s-text-black-500"
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </section>
        </div>
      ) : (
        <section className="s-px-3">
          <div className="s-flex">
            <div className="s-flex-1">
              <div>
                <div>
                  <div className="s-mt-14px s-mb-7px s-text-category-title s-text-15px s-leading-snug">
                    Popular
                  </div>

                  {data?.map((res) => {
                    return (
                      <div style={theme == 'light' ? {background:"#37383c",color:"white"} : {}}
                        onClick={() => setActive(res)}
                        className="s-flex s-py-10px s-px-14px s-justify-between s-items-center s-bg-white dark:s-bg-main-block-dark s-rounded-5px s-text-15px s-shadow-sm s-mb-1px"
                      >
                        <span className="s-icon-top s-text-16px s-mr-8px dark:s-text-global-font-default-dark" />
                        <span className="s-leading-18px s-flex-1 s-text-17px s-font-bold s-break-words dark:s-text-global-font-default-dark">
                          {res?.seriesName}
                        </span>
                        <span className="s-icon-arrow-left s-transform s-rotate-180 s-text-12px s-text-black-500 dark:s-text-black-600 s-pr-14px" />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default Leagues;
